import { defineSpriteViewerElement } from './viewer/element.js'

defineSpriteViewerElement()

export { defineSpriteViewerElement } from './viewer/element.js'
export type {
  SpriteViewerColorTheme,
  SpriteViewerElement,
  SpriteViewerManifest,
  SpriteViewerManifestColor,
  SpriteViewerManifestIcon,
  SpriteViewerManifestLoader,
  SpriteViewerManifestModule,
  SpriteViewerManifestUsage,
  SpriteViewerRemoteSource,
  SpriteViewerSource,
  SpriteViewerSources,
} from './viewer/types.js'
